module.exports = __webpack_public_path__ + "static/media/logout.aef9b61e.svg";